<template>
    <section class="view spacer">
        <vue-headful
            title="HR View | What goes into a HR View"
            description="HR View Grasps the make-up of your workforce, anticipate changes, and identify resource needs. Track and project the costs and flow of resources throughout the human capital lifecycle."
            url="https://www.fedsight.com/hr-view"
        />
        <section class='container-fluid d-flex align-items-center justify-content-center'>
        </section>

        <section class='viewIntro'>
            <div class='container'>
                <h1 class='viewHeader fedsightBlue'>HR VIEW</h1> 
                <p class='viewMainParagraph'>
                    Federal employees carry the very important responsibility of executing programs that protect, save and better American's lives. With that in mind, managers and leaders need to effectively align human resources to maximize mission effectiveness. HR View provides insight into current staffing and allows you to rapidly model future needs and opportunities to effectively plan for the future. Both financial and operational data are combined in order to form a complete view of your organization's human capital. HR View also provides visibility into all aspects of the human capital lifecycle in order to plan, manage and facilitate events such as hiring, promotions and retirement. With HR View your organization will be armed with the insight necessary to staff a highly effective workforce. 
                </p>
            </div>
            
        </section>

        <section class='blogPost'>
            <div class='container blogPostContainer'>
                <h2 class='fedsightBlue' style='margin-top: 0rem;'>
                    Key Business Questions:
                </h2>
                <ul>
                    <li>
                        What is the balance between mission focused staff and administrative support staff? How do we compare to other organizations?
                    </li>
                    <li>
                        What is the human capital profile for my organization overall, by function, and by geography? Do we have the optimal mix of resources with the right experience and skills?
                    </li>
                    <li>
                        What is the management to staff ratio overall and within administrative and programmatic functions? How do we compare to other organizations?
                    </li>
                    <li>
                        What have the trends been over time related to new hires and staffing across all organizations and programs?
                    </li>
                    <li>
                        To what extent do historical Human Capital decisions impact our ability to effectively execute our mission and the impact if trends continue?
                    </li>
                    <li>
                        To what extent does our organization use federal resources vs. contractors/grants to execute key functions and is the balance in sync with mission and cost objectives?
                    </li>
                </ul>
            </div>

            <div class='container blogPostContainer'>
                <h2 class='fedsightBlue' style='margin-top: 0rem;'>
                    Who we are
                </h2>
                <p>
                    Fedsight Consulting is an SBA certified HUBZone small business consulting firm focused on helping organizations improve operations and program performance. Our strategic, financial, and operational support services provide insight and perspective on program performance and operational trends.  Fedsight Consulting’s subject matter expertise, methods, and tools enable federal organizations to accomplish objectives, effectively manage resources, and improve program performance.
                </p>
                <p>
                    To learn more about Fedsight Consulting and discuss potential opportunities, email <span class='emailLink' @click='emailUs()'>info@fedsight.com</span>.
                </p>
            </div>
        </section>

        <Footer />
  </section>
</template>

<script>
import Footer from '@/components/Footer.vue'
import closeMenu from '../../mixins/closeMenu'


export default {
    name: 'hr-view',
    components: {
        Footer
    },
    metaInfo: {
      link: [
        {rel:'canonical', href:'https://www.fedsight.com/hr-view'}
      ]
    },
    mixins: [closeMenu],
    methods: {
      emailUs(){
          window.location.href = "mailto:info@fedsight.com?subject=I%20would%20like%20to%20learn%20more%20about%20Fedsight&body=Hello,%0D%0A%0D%0APlease%20contact%20me%20to%20discuss%20how%20Fedsight%20can%20assist%20my%20company.%0D%0A%0D%0A";
      }
    },
    mounted() {
        document.dispatchEvent(new Event('page.rendered'));
    }
}
</script>

<style scoped>
.viewIntro{
    padding: 8rem 0rem 2rem;
    max-width: 100rem;
    margin: auto;
    text-align: left;
}
.viewHeader{
    font-size: 4rem;
    font-weight: bold;
    text-align: center;
    /*background-color: #132631;
    color: #fff; */
    width: 100%;
    padding: 2rem 0rem;
}
.blogPost{
    text-align: left;
}
.blogPostContainer{
    max-width: 100rem;
    margin: 3rem auto;
}
.viewHero{
    height: 30rem;
}
.viewHeader{
    color: #fff;
    font-size: 6rem;
}
.emailLink{
    color: #007bff;
    cursor: pointer;
}
.emailLink:hover{
    color: #0056b3;
    text-decoration: underline;
}
h2{
    margin-top: 3rem;
}


/* Small devices (landscape phones, 576px and up) */
  @media (max-width: 576px) { 
    .slogan {
      font-size: 3.5rem !important;
    }
  }

  @media (max-width: 768px) { 
    .slogan{
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
  }

  @media (max-width: 992px){
    .container{
        padding: 1.5rem !important;
    }
  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) { 
    
    .slogan {
      font-size: 9rem !important;
    }
  }
</style>